var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTarget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0001 23.4667C20.1238 23.4667 23.4667 20.1237 23.4667 16C23.4667 11.8763 20.1238 8.53335 16.0001 8.53335C11.8764 8.53335 8.53341 11.8763 8.53341 16C8.53341 20.1237 11.8764 23.4667 16.0001 23.4667ZM16.0001 26.6667C21.8911 26.6667 26.6667 21.8911 26.6667 16C26.6667 10.109 21.8911 5.33335 16.0001 5.33335C10.109 5.33335 5.33341 10.109 5.33341 16C5.33341 21.8911 10.109 26.6667 16.0001 26.6667Z",
    fill: "url(#paint0_linear_522_8728)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 2.66669H17.3334V6.66669H14.6667V2.66669Z",
    fill: "url(#paint1_linear_522_8728)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3334 17.3334V14.6667H29.3334V17.3334H25.3334Z",
    fill: "url(#paint2_linear_522_8728)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 17.3334V14.6667H6.66675V17.3334H2.66675Z",
    fill: "url(#paint3_linear_522_8728)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 25.3334H17.3334V29.3334H14.6667V25.3334Z",
    fill: "url(#paint4_linear_522_8728)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3334 16C19.3334 17.841 17.841 19.3334 16.0001 19.3334C14.1591 19.3334 12.6667 17.841 12.6667 16C12.6667 14.1591 14.1591 12.6667 16.0001 12.6667C17.841 12.6667 19.3334 14.1591 19.3334 16Z",
    fill: "url(#paint5_linear_522_8728)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_522_8728",
    x1: 16.0001,
    y1: 2.66669,
    x2: 16.0001,
    y2: 29.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C2C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_522_8728",
    x1: 16.0001,
    y1: 2.66669,
    x2: 16.0001,
    y2: 29.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C2C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_522_8728",
    x1: 16.0001,
    y1: 2.66669,
    x2: 16.0001,
    y2: 29.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C2C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_522_8728",
    x1: 16.0001,
    y1: 2.66669,
    x2: 16.0001,
    y2: 29.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C2C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_522_8728",
    x1: 16.0001,
    y1: 2.66669,
    x2: 16.0001,
    y2: 29.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C2C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_522_8728",
    x1: 16.0001,
    y1: 2.66669,
    x2: 16.0001,
    y2: 29.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C2C2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTarget);
export default __webpack_public_path__ + "static/media/icon_target.7baa47929f5f6aef2bed1d20c0d5d6ea.svg";
export { ForwardRef as ReactComponent };